import React from 'react';
import promotion_config from '../../../promotion_config';
import EntryForm from './entry_form';
import Error from './error';
import ticketFront from './images/il-ticket.png';
import './style.scss';

export const EntryInner = ({ entry, drawTicket, game, animation, actions }) => {
    return (
        <div className="entry-div">
            <div className="flush-row">
                <div className="col-sm-10 col-sm-offset-1 text-center entry-info">
                    <div className="description">
                        <p>
                            To enter, type the WEB CODE from one of the non-winning Illinois Lottery
                            Twelve Weeks of Holiday Winnings 2nd Chance Promotion Instant Tickets
                            (i.e., Games 7532, 7533, 7534, 7535, and 7536) where indicated in the spaces below.
                        </p>
                    </div>
                    <div className="valid-entries">
                        <p>
                            Only valid internet entries shall be accepted.
                            <br />
                            Mailing tickets to the Illinois Lottery is not a
                            valid form of entry.
                        </p>
                    </div>
                </div>

                <div id="entry-alert">
                    <Error drawTicket={drawTicket} actions={actions} />
                </div>

                <div className="col-sm-12 entry-container">
                    <div className="entry-panel">
                        <EntryForm
                            promotion_id={promotion_config.promotion_id}
                            promotion={promotion_config.promotion}
                            appUrl={promotion_config.appUrl}
                            drawTicket={drawTicket}
                            entry={entry}
                            game={game}
                            animation={animation}
                            actions={actions}
                            createfunc={
                                actions.drawTicketActions.enterDrawTicket
                            }
                        />
                    </div>
                </div>

                <div className="col-xs-12 col-sm-12">
                    <div className="entry-panel ticket-demo">
                        <div style={{ textAlign: 'center' }}>
                            <label className="sr-only">
                                WEB CODE ON FRONT
                            </label>
                        </div>
                        <img
                            src={ticketFront}
                            alt="Web Code on ticket front."
                            className="img-responsive center-block"
                        />
                        <div className="sr-only">
                            The Web Code is a 10-digit number in the
                            game play area on the ticket front.
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default EntryInner;
